import { getAppConfiguration } from '@utils/browserEnv';
import { cmsGraphQLClient } from '@app/graphQLClient';
import { Layout } from '@components/Layout';
import { GetStaticProps } from 'next';
import { FC } from 'react';
import { AllFeaturesPage } from 'sailor-ui/pages';
import { GetMenuFeaturedPages, useGetMenuFeaturedPages } from 'services/graphql/cms';

const { appCode } = getAppConfiguration();

type Props = {
  featuredData: GetMenuFeaturedPages;
};

const FeaturesPage: FC<Props> = ({ featuredData }) => {
  const metaData = {
    title: 'Features',
  };

  return (
    <Layout meta={metaData}>
      <AllFeaturesPage data={featuredData} appCode={appCode} />
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const fetchedFeaturedPages = await useGetMenuFeaturedPages.fetcher(cmsGraphQLClient, { appCode })();

  if (fetchedFeaturedPages) {
    return {
      props: {
        featuredData: fetchedFeaturedPages,
      },
      revalidate: 5,
    };
  }

  return {
    notFound: true,
  };
};

export default FeaturesPage;
